import { render, staticRenderFns } from "./DocentesCategorizadosPage.vue?vue&type=template&id=606d9060"
import script from "./DocentesCategorizadosPage.js?vue&type=script&lang=js&external"
export * from "./DocentesCategorizadosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports